import React, { useState } from 'react';
import { Box, IconButton, Popover, TextField, Button } from '@mui/material';
import { FilterList as FilterListIcon } from '@mui/icons-material';

const CustomHeaderComponent = (props) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const [filterValue, setFilterValue] = useState('');

    const handleFilterClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleApplyFilter = () => {
        if (props.api) {
            const filterInstance = props.api.getFilterInstance(props.column.colId);
            if (filterInstance) {
                filterInstance.setModel({
                    type: 'contains',
                    filter: filterValue
                });
                props.api.onFilterChanged();
            }
        }
        handleClose();
    };

    const handleClearFilter = () => {
        if (props.api) {
            const filterInstance = props.api.getFilterInstance(props.column.colId);
            if (filterInstance) {
                filterInstance.setModel(null);
                props.api.onFilterChanged();
            }
        }
        setFilterValue('');
        handleClose();
    };

    const open = Boolean(anchorEl);

    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" width="100%">
            <span>{props.displayName}</span>
            <IconButton size="small" onClick={handleFilterClick}>
                <FilterListIcon fontSize="small" />
            </IconButton>
            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left'
                }}
            >
                <Box p={2} minWidth={200}>
                    <TextField
                        fullWidth
                        size="small"
                        label={`Filter ${props.displayName}`}
                        value={filterValue}
                        onChange={(e) => setFilterValue(e.target.value)}
                        onKeyPress={(e) => {
                            if (e.key === 'Enter') {
                                handleApplyFilter();
                            }
                        }}
                    />
                    <Box display="flex" gap={1} mt={1}>
                        <Button size="small" onClick={handleApplyFilter} variant="contained">
                            Apply
                        </Button>
                        <Button size="small" onClick={handleClearFilter}>
                            Clear
                        </Button>
                    </Box>
                </Box>
            </Popover>
        </Box>
    );
};

export default CustomHeaderComponent;
